import { render, staticRenderFns } from "./Zxlist.vue?vue&type=template&id=1e142764&scoped=true"
import script from "./Zxlist.vue?vue&type=script&lang=js"
export * from "./Zxlist.vue?vue&type=script&lang=js"
import style0 from "./Zxlist.vue?vue&type=style&index=0&id=1e142764&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e142764",
  null
  
)

export default component.exports